module.exports = __webpack_public_path__ + "static/media/ethereum.9b7a95a5.svg";